<template>
    <section 
        id="benefits-section" 
        class="py-20 my-20" 
        :class="context.isDarkMode ? 'bg-semidark-silver' : 'bg-void'" 
    >
        <div class="mx-5 md:mx-40 px-5 md:px-10">
            <i class="pi pi-crown text-center text-white w-full mb-5 text-8 xl:text-12"></i>
            <p class="text-4xl xl:text-2xl 2xl:text-4xl font-bold text-center mb-10 text-silver">
                {{ translationHandler.translate('why choose us?', 'ucfirst') }}
            </p>

            <div class="mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-5">
                <div 
                    v-for="(benefit, index) of benefitsList" 
                    :key="index" 
                    class="py-8 px-5 shadow-lg rounded-lg mx-2 trigger-benefits-el"
                >
                    <img :src="benefit.image" class="mx-auto rounded-3xl enlarge-top-effect" :alt="benefit.title + ' image'" />
                    <p class="text-xl font-bold text-white my-5 text-white h-20 2xl:h-16">
                        {{ translationHandler.translate(benefit.title, 'ucfirst') }}:
                    </p>
                    <p class="font-semibold text-main-gray">
                        {{ translationHandler.translate(benefit.text, 'ucfirst') }}
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import AnimationHandler from '@/composables/handlers/AnimationHandler';
import translationHandler from '@/composables/handlers/TranslationHandler';
import { useContextStore } from '@/stores/context';
import { onMounted, ref } from 'vue';

const context = useContextStore();

onMounted(() => {
    handleAnimation();
});

async function handleAnimation() {
    const data = [
        {
            mainClass: 'trigger-benefits-el',
            classesToUse: ['bg-third-color'],
            startInterval: 500,
            intervalPerAction: 500,
            triggerAt: '#benefits-section',
            triggerDistance: 5
        }
    ];
    (new AnimationHandler(data)).watchScrollAndAnimate();

}

const benefitsList = ref([
    {
        title: 'Your Store Open 24/7', 
        image: require('@/assets/images/benefits/open-24_statue.png'),
        text: 'Your business is open around the clock with a digital storefront, allowing you to reach and sell to customers anywhere, anytime.'
    },
    {
        title: 'Online Authority and Credibility', 
        image: require('@/assets/images/benefits/online-authority_statue.png'),
        text: 'We build a professional website that establishes trust and credibility, ensuring your brand stands out from the competition.'
    },
    {
        title: 'Efficiency and Growth with Technology', 
        image: require('@/assets/images/benefits/efficiency_statue.png'),
        text: 'Our soluções de tecnologia personalizadas automatizam tarefas e otimizam processos, liberando você para focar no crescimento do seu negócio.'
    },
    {
        title: 'Strategic Decisions with Data', 
        image: require('@/assets/images/benefits/strategic-decisions_statue.png'),
        text: 'We provide powerful insights from valuable data collected from the web, helping you make smarter, data-driven decisions for your company\'s future.'
    }
]);

</script>